<div class="box-border w-full text-base">
  @let hasError = ngControl.errors && ngControl.touched;
  <div
    (click)="toggle()"
    class="flex cursor-pointer items-center rounded-sm"
    [ngClass]="{
      'cursor-not-allowed!': ngControl.control!.disabled,
    }">
    <input
      [attr.data-testid]="id() | appendTestId: 'input'"
      type="checkbox"
      [id]="id()"
      [formControl]="ngControl.control! | toFormControl"
      class="pointer-events-none sr-only h-5 w-5" />
    <div
      class="border-input-ring flex h-6 w-6 items-center justify-center border rounded-sm"
      [ngClass]="{
        'bg-transparent': !ngControl.value,
        'bg-primary-main':
          ngControl.value && !ngControl.disabled,
        'bg-standard-text-disabled/50': ngControl.value && ngControl.disabled,
        'border-input-focus border-2':
          !hasError && !ngControl.disabled && !ngControl.value,
        'cursor-not-allowed!': ngControl.disabled,
        'border-input-error!': hasError,
      }">
      <span
        class="material-symbols-rounded text-primary-on pt-0.5"
        [class.invisible]="!ngControl.value"
        [class.text-white]="ngControl.control!.disabled">
        check
      </span>
    </div>

    @if (formattedLabel()) {
      <label
        [attr.data-testid]="id() | appendTestId: 'label'"
        [for]="id()"
        [ngClass]="{
          'cursor-not-allowed!': ngControl.control!.disabled,
        }"
        class="text-standard-text-primary pointer-events-none flex w-full cursor-pointer gap-2 pl-3 text-base">
        {{ formattedLabel() }}
      </label>
    }
  </div>
  @if (hasError) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      @if (errorTemplate()) {
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      } @else {
        <ng-content></ng-content>
      }
    </aw-error-message>
  }
</div>
